/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { useTheme } from '../../../providers/theme';
import { useSMSignInUser } from '../machines/signInUser';
import { logger as log } from '@common/logger';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { vappContainer, VApplication } from '../../../application';

import { useSMSignInPageGetContent } from '../machines/pageContent';
import {
  PageContainer,
  GoBackLink,
  Heading,
  Logo,
  FormComp,
  SubmitButton,
  OTPComp,
  SubHeading,
  ImageIcon,
  TopAuthorsWidget,
  GoBackArrow,
} from '../components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { useSMGetSignInType } from '../machines/getSignInType';
import { useSMSendOTP } from '../machines/sendOTP';
// import { fillTemplate } from "@vlinder-web/utils-react";
import { AppNavigatorService } from '@/AppNavigator';
import { SignInPageService } from '@/pages/SignIn';
import { ProfilePageService } from '@pages/Profile';
import { USER_LEVEL } from '@/config/userManagement.config';
import { Loader } from '@/components';
import { RoleComp } from '@/pages/SwitchRoles/components';
import styled from 'styled-components';

const MODULE_NAME = 'signInPage';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const getProfileSrv = () => {
  return vappContainer.get<ProfilePageService>(ProfilePageService.displayName);
};

const loginPageServ = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
const ImgContainer = styled.div`
  width: 42%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;
const RightContainer = styled.div`
  width: 58%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 4%;
  padding-right: 4%;
  @media (max-width: 768px) {
    width: 92%;
  }
`;
const Container = styled.div`
  display: flex;
  // min-width: 90%;
  width: 70%;
  height: 70vh;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;
export const ContainerComm = (props: any) => {
  const theme = useTheme();
  let navigate = useNavigate();
  const { signInUserMachine, signInUserSend, signInUserState } =
    useSMSignInUser({});
  const { getSignInTypeState, getSignInTypeSend } = useSMGetSignInType({});
  const { sendOTPState, sendOTPSend } = useSMSendOTP({});
  const { signInPageGetContentState } = useSMSignInPageGetContent({});
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const [renderOTPScreen, setRenderOTPScreen] = React.useState<any>();
  const [whoAmI, setWhoAmI] = React.useState<string>('');
  const [email, setEmail] = React.useState<string>('');
  console.log(staticPageContentConfig);
  const urlParams = new URLSearchParams(window.location.search);
  let invitemail = urlParams.get('email');
  // let invitemail =
  const getWhoAmI = async () => {
    const { whoami } = await loginPageServ()?.whoAmI();
    console.log('hifi->', whoami);
    setWhoAmI(whoami);
  };

  // useEffect(() => {
  //   if (signInUserState?.matches('RENDER_ACCOUNT_SELECTION')) {
  //     console.log(signInUserState?.context?.signInRes);

  //     const roles = signInUserState?.context?.signInRes?.userRoles || [];

  //     const item =
  //       roles.find((role: any) => role.name === 'Caricom_Business_Org') ||
  //       roles.find((role: any) => role.name === 'Owner') ||
  //       roles.find((role: any) => role.name === 'admin') ||
  //       roles[0];

  //     if (item) {
  //       onRoleSelect({
  //         roleId: item.uuid,
  //         name: item.name,
  //         token: signInUserState?.context?.signInRes?.signInToken,
  //       });
  //     }
  //   }
  // }, [signInUserState?.context?.signInRes]);

  useEffect(() => {
    if (signInUserState?.matches('RENDER_ACCOUNT_SELECTION')) {
      console.log(signInUserState?.context?.signInRes);

      const roles = signInUserState?.context?.signInRes?.userRoles || [];

      const hasCaricomBusinessOrg = roles.some(
        (role: any) => role.name === 'CARICOM_BUSSINESS_ORG'
      );
      const hasAdmin = roles.some((role: any) => role.name === 'admin');
      const hasOwner = roles.some((role: any) => role.name === 'owner');

      let passing_role: any;
      if (hasOwner) {
        passing_role = roles.find((role: any) => role.name === 'owner');
      } else if (hasAdmin) {
        passing_role = roles.find((role: any) => role.name === 'admin');
      } else if (hasCaricomBusinessOrg) {
        passing_role = roles.find(
          (role: any) => role.name === 'CARICOM_BUSSINESS_ORG'
        );
      } else {
        passing_role = roles[0];
      }

      onRoleSelect({
        roleId: passing_role.uuid,
        name: passing_role.name,
        token: signInUserState?.context?.signInRes?.signInToken,
      });
    }
  }, [signInUserState?.context?.signInRes]);

  useEffect(() => {
    getWhoAmI();
  }, []);

  useEffect(() => {
    let token = loginPageServ()?.getToken();
    if (token) {
      if (whoAmI !== '') {
        console.log('whom->', whoAmI);
        if (USER_LEVEL.owner.includes(whoAmI) && whoAmI !== 'issuer') {
          window.open(`/profile/organization-profile`, '_self');
        } else {
          window.open(`/profile/my-profile`, '_self');
        }
      }
    }
  }, [whoAmI]);

  console.log(
    signInUserState?.value,
    signInUserState?.matches('SIGN_IN_USER_SUCCESS'),
    signInUserState?.event?.data?.value,
    'ljp->'
  );
  useEffect(() => {
    const data = {
      ...signInUserState?.context?.signInRes,
      ...signInUserState?.event?.data?.value,
    };
    if (signInUserState?.matches('SIGN_IN_USER_SUCCESS') && data) {
      //getProfileSrv().agent.getProfile({});
      console.log('hifi->', signInUserState?.event?.data?.value);
      console.log('hifi->login', Object.entries(data), Object.keys(data));

      if (data?.emailVerified) {
        if (
          data?.userRoles[0]?.uuid === '2324e90f-6843-48e0-8f70-84ca5461a0de' ||
          data?.orgRole === 'ISSUER'
        ) {
          window.open(`/profile/my-profile`, '_self');
        } else if (
          USER_LEVEL.owner.includes(
            data?.currentRole ?? data?.userRoles?.[0]?.name
          )
        ) {
          window.open(`/profile/organization-profile`, '_self');
        } else {
          window.open(`/profile/my-profile`, '_self');
        }
      } else {
        const __email = getSrv()?.getUserEmail();
        setEmail(__email);
        sendOTPSend('START', {
          payload: {
            email: __email,
          },
        });
        if (!renderOTPScreen)
          setTimeout(() => {
            setRenderOTPScreen(true);
          }, 1000);
        console.log(
          'signintype',
          getSignInTypeState?.event?.data?.value?.signInType
        );
      }
      // window.open(`${routes?.SelectProduct?.path}`, "_self");
    }
  }, [
    signInUserState?.matches('SIGN_IN_USER_SUCCESS') &&
      signInUserState?.event?.data?.value,
  ]);

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onIdentifierSubmit = (data: any) => {
    // getSignInTypeSend("START", {
    //   payload: {
    //     email: data?.email,
    //   },
    // });
    signInUserSend('START', {
      payload: {
        email: data.email,
        password: data.password,
        rememberMe: data.rememberMe,
      },
    });
  };

  const onLoginSubmit = (email: string, data: any) => {
    // console.log(`sign in user Click`, data);
    signInUserSend('START', {
      payload: {
        email: data.email,
        password: data.password,
        rememberMe: data.rememberMe,
      },
    });
  };

  const onOTPSubmit = (data: any) => {
    signInUserSend('START', {
      payload: {
        email: email,
        otp: data.otp,
      },
    });
  };

  const _handleResendClick = (email: string) => {
    sendOTPSend('START', {
      payload: {
        email: email,
      },
    });
  };

  const _onSignIn = (email: string, password: string, rememberMe: boolean) => {
    signInUserSend('START', {
      payload: {
        email: email,
        password: password,
        rememberMe: rememberMe,
      },
    });
  };

  const onRoleSelect = (role: any) => {
    const { roleId, name, token } = role;
    signInUserSend('GET_ACCESS_TOKEN', {
      payload: {
        jwtToken: token,
        role: roleId,
        name,
      },
    });
  };

  const _getSuccessNotification = () => {};
  const _getErrorNotification = () => {
    if (
      getSignInTypeState?.matches('GET_SIGN_IN_TYPE_FAILURE') &&
      getSignInTypeState?.event?.data?.value
    ) {
      toast.error(getSignInTypeState?.event?.data?.value);
    }

    if (signInUserState?.matches('SIGN_IN_USER_ERROR')) {
      toast.success('Logged in successfully!');
    }
  };
  const _getPageLoading = () => {
    if (
      signInPageGetContentState?.matches('GET_PAGE_CONTENT') ||
      getSignInTypeState?.matches('GET_SIGN_IN_TYPE') ||
      signInUserState?.matches('GET_ACCESS_TOKEN') ||
      signInUserState?.matches('SIGN_IN_USER') ||
      (signInUserState?.matches('SIGN_IN_USER_SUCCESS') && !renderOTPScreen)
    ) {
      console.log('jramstate1');
      return (
        <Loader {...(staticPageContentConfig?.loading?.GetPageLoading || {})} />
      );
    }
  };
  const _getPageContent = () => {
    if (
      signInPageGetContentState?.matches('GET_PAGE_CONTENT') ||
      getSignInTypeState?.matches('GET_SIGN_IN_TYPE') ||
      signInUserState?.matches('GET_ACCESS_TOKEN') ||
      signInUserState?.matches('SIGN_IN_USER') ||
      (signInUserState?.matches('SIGN_IN_USER_SUCCESS') && !renderOTPScreen)
    ) {
      console.log('jramstate1');
      return (
        <></>
        // <Loader {...(staticPageContentConfig?.loading?.GetPageLoading || {})} />
      );
    }

    if (signInUserState?.matches('RENDER_ACCOUNT_SELECTION')) {
      console.log('jramstate2');
      return (
        <Col lg={5} md={8} sm={12}>
          <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
          <GoBackArrow />
          {/* <TopAuthorsWidget
            title={'Select your Account'}
            authors={signInUserState?.context?.signInRes?.userRoles}
            onRowClick={onRoleSelect.bind(
              null,
              signInUserState?.context?.signInRes?.signInToken
            )}
            
          /> */}

          <RoleComp
            {...signInUserState?.context?.signInRes}
            current={props?.whoami}
            onRoleSelect={onRoleSelect}
          />
        </Col>
      );
    }

    if (
      getSignInTypeState?.matches('GET_SIGN_IN_TYPE_SUCCESS') &&
      signInUserState?.nextEvents?.includes('START')
    ) {
      console.log('jramstate3');
      if (getSignInTypeState?.event?.data?.value?.signInType === 'password') {
        console.log('state3pass');
        return (
          <Col xs={12} md={12} lg={5}>
            <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
            <GoBackLink />
            <Heading
              title={staticPageContentConfig?.header?.identifier?.title}
            />
            <FormComp
              renderSubmitButton={renderSubmitButton}
              authType={'PASSWORD'}
              onFormSubmit={onLoginSubmit.bind(
                null,
                getSignInTypeState?.event?.data?.value?.email
              )}
              initialData={{
                email: getSignInTypeState?.event?.data?.value?.email,
              }}
            />
          </Col>
        );
      }
      if (getSignInTypeState?.event?.data?.value?.signInType === 'otp') {
        console.log('state3otp');
        return (
          <Col md={4} xs={11}>
            <Logo logoURL={staticPageContentConfig?.header?.otp?.logo} />
            <GoBackLink />
            <Heading title={staticPageContentConfig?.header?.otp?.title} />
            <ImageIcon
              imageIconURL={staticPageContentConfig?.header?.otp?.iconURL}
              height={100}
            />
            {/* <SubHeading
              subHeadingText={fillTemplate(
                staticPageContentConfig?.header?.otp?.subHeadingText,
                { email: getSignInTypeState?.event?.data?.value?.email }
              )}
            /> */}
            <OTPComp
              renderSubmitButton={renderSubmitButton}
              onFormSubmit={onOTPSubmit.bind(
                null,
                getSignInTypeState?.event?.data?.value?.email
              )}
              onResendClick={_handleResendClick.bind(
                null,
                getSignInTypeState?.event?.data?.value?.email
              )}
            />
          </Col>
        );
      }

      return null;
    }

    if (renderOTPScreen) {
      console.log('render otp screen sign in user success', getSignInTypeState);
      return (
        <div>
          {/* <Logo logoURL={staticPageContentConfig?.header?.otp?.logo} /> */}
          <GoBackLink />
          <Heading title={staticPageContentConfig?.header?.otp?.title} />
          <ImageIcon
            imageIconURL={staticPageContentConfig?.header?.otp?.iconURL}
            height={100}
          />
          {/* <SubHeading
            subHeadingText={fillTemplate(
              staticPageContentConfig?.header?.otp?.subHeadingText,
              { email: getSignInTypeState?.event?.data?.value?.email }
            )}
          /> */}
          <OTPComp
            renderSubmitButton={renderSubmitButton}
            // onFormSubmit={onOTPSubmit.bind(
            //   null,
            //   getSignInTypeState?.event?.data?.value?.email
            // )}
            onFormSubmit={onOTPSubmit}
            onResendClick={_handleResendClick.bind(
              null,
              getSignInTypeState?.event?.data?.value?.email
            )}
          />
        </div>
      );
    }

    if (
      signInPageGetContentState?.matches('RENDER_PAGE') &&
      getSignInTypeState?.nextEvents?.includes('START')
    ) {
      return (
        <Container style={{ margin: 'auto' }}>
          <ImgContainer>
            <img
              src="https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png"
              height="80%"
              width="80%"
            />
          </ImgContainer>
          <RightContainer>
            <div>
              {/* <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
          <GoBackLink /> */}
              <Heading
                title={staticPageContentConfig?.header?.identifier?.title}
              />
              <FormComp
                renderSubmitButton={renderSubmitButton}
                initialData={invitemail ? { email: invitemail } : {}}
                authType={'PASSWORD'}
                onFormSubmit={onIdentifierSubmit}
              />
            </div>
          </RightContainer>

          <GoBackLink />
        </Container>
      );
    }
  };
  const _getPageContents = () => {
    if (
      signInPageGetContentState?.matches('GET_PAGE_CONTENT') ||
      getSignInTypeState?.matches('GET_SIGN_IN_TYPE') ||
      signInUserState?.matches('GET_ACCESS_TOKEN') ||
      signInUserState?.matches('SIGN_IN_USER') ||
      (signInUserState?.matches('SIGN_IN_USER_SUCCESS') && !renderOTPScreen)
    ) {
      return <></>;
    } else {
      return _getPageContent();
    }
  };
  return (
    <PageContainer>
      {_getSuccessNotification()}
      {_getErrorNotification()}
      {_getPageLoading()}
      {/* <div style={{display:'flex',minWidth:'90%',width:'90%',height:'70vh',backgroundColor:'white',boxShadow:'0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}>

        <div style={{width:'42%',display:'flex',justifyContent:'center',alignItems:'center'}}>
          <img src='https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png' height='80%' width='80%'/>
        </div>
        <div style={{width:'58%',display:'flex',justifyContent:'center',alignItems:'center',paddingLeft:'4%',paddingRight:'4%'}}> */}

      {_getPageContents()}
      {/* </div> */}

      {/* <GoBackLink/> */}
      {/* </div> */}
    </PageContainer>
  );
};
